import { render } from "./attention-required-events.vue?vue&type=template&id=6a17a72c&scoped=true&lang=pug"
import script from "./attention-required-events.vue?vue&type=script&setup=true&lang=js"
export * from "./attention-required-events.vue?vue&type=script&setup=true&lang=js"

import "./attention-required-events.vue?vue&type=style&index=0&id=6a17a72c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a17a72c"]])

export default __exports__